export const Endpoints = {
  /** Tarayıcı error boundary → user-api-gw Winston log (CloudWatch) */
  CLIENT_ERROR_REPORT: '/web/client-error',
  INIT: '/user/init',
  SIGNUP: '/user/signup',
  SIGNUP_VERIFY: '/user/signup/verification',
  LOGIN: '/user/login',
  LOGIN_OTP_REQUEST: '/user/login-otp-request',
  LOGIN_WITH_ORDER_CODE: '/user/login-with-order-code',
  SET_PASSWORD_AFTER_PANEL_CLAIM: '/user/set-password-after-panel-claim',
  GET_SELF: '/user/get-self',
  GET_NOTIFICATION_LIST: '/user/get-notification-list',
  GET_VIDEO_MESSAGE_LINK: '/user/get-video-message-link',
  UPDATE_PASSWORD: '/user/update-password',
  LOGOUT: '/user/logout',
  EDIT_USER: '/user/edit',
  FORGOT_PASSWORD: '/user/forgot-password',
  RECOVER_PASSWORD: '/user/recover-password',
  HOMEPAGE: '/product/homepage',
  CATEGORY: '/product/category',
  SEARCH: '/product/search',
  PRODUCT: '/product/product',
  SETTINGS: '/product/settings',
  GET_HELP_BUTTON_ID: '/product/get-help-button-id',
  FILTERS: '/product/filters',
  BOTTOM_MENU: '/product/bottom-menu',
  MAIN_CATEGORY: '/product/main-category',
  GET_ALL_PRODUCTS: '/product/all-products',
  GET_EXTRA_PRODUCTS: '/product/extra-products',
  GET_CHECKOUT_EXTRA_CATEGORIES: '/product/checkout-extra-categories',
  GET_RECOMMENDED_PRODUCTS: '/product/recommended-products',
  GET_PHOTO_PRINT_PRODUCTS: '/product/photo-print-products',
  GET_SLUGS: '/product/slugs',
  GET_SITEMAP_URLS: '/product/sitemap-urls',
  GET_ALLOWED_PATHS: '/product/allowed-paths',
  GET_SLUG: '/product/slug',
  RESOLVE_REDIRECT: '/product/resolve-redirect',
  DELIVERY_TIMES: '/product/delivery-times',
  DELIVERY_FEE_INFO: '/product/get-delivery-fee-info',
  BASKET_ADD_ITEM: '/basket/add-item',
  BASKET_REMOVE_ITEM: '/basket/remove-item',
  BASKET_INCREASE_ITEM: '/basket/increase-item',
  BASKET_DECREASE_ITEM: '/basket/decrease-item',
  GET_BASKET: '/basket/get',
  BASKET_UPDATE_RECEIVER: '/basket/update-receiver',
  BASKET_LOG_RECEIVER_AREA: '/basket/log-receiver-area',
  BASKET_UPDATE_SENDER: '/basket/update-sender',
  BASKET_UPDATE_MESSAGE: '/basket/update-message',
  BASKET_APPLY_PROMO: '/basket/apply-promo',
  BASKET_REMOVE_PROMO: '/basket/remove-promo',
  BASKET_APPLY_CARD_DISCOUNT: '/basket/apply-card-discount',
  BASKET_REMOVE_CARD_DISCOUNT: '/basket/remove-card-discount',
  GET_PRODUCT_CARD_MESSAGE_CATEGORIES: '/product/get-message-categories',
  GET_PRODUCT_CARD_MESSAGES: '/product/get-messages',
  GET_PAYMENT_TYPES: '/order/get-payment-types',
  /** Araç süslemesi: depo + güne göre dolu saatler */
  GET_DECORATION_TIMES: '/order/decoration-times',
  GET_BANK_ACCOUNTS: '/product/bank-accounts',
  GET_REVIEWS: '/product/reviews',
  START_ORDER: '/order/start',
  MILES_SMILES_MEMBER: '/order/miles-smiles/member',
  MILES_SMILES_ISSUE: '/order/miles-smiles/issue',
  COMPLETE_ORDER: '/order/complete',
  IYZICO_3DS_INIT: '/order/iyzico-3ds-init',
  IYZICO_CARDS: '/order/iyzico-cards',
  IYZICO_CARDS_DELETE: '/order/iyzico-cards/delete',
  GET_QUICK_SEARCH: '/product/search-quick',
  GET_SEO: '/product/seo',
  GET_ORDER_LIST: '/order/get-list',
  GET_ORDER: '/order/get',
  GET_ORDER_BY_NUMBER: '/order/get-by-order-number',
  UPDATE_ORDER_CUSTOMER_CONTENT: '/order/update-customer-content',
  GET_RECEIVERS: '/order/get-receivers',
  ADD_REVIEW: '/order/add-review',
  IYZICO_CALLBACK: '/callback/iyzico',
  BLOG_LIST: '/product/blogs',
  BLOG_DETAIL: '/product/blog',
  VODAFONE_SEND_ACTIVATION_OTP: '/order/vodafone-send-activation-otp',
  VODAFONE_ACTIVATE: '/order/vodafone-activate',
  GET_LAST_ORDER: '/order/get-last',
  GET_ORDER_FOR_FEEDBACK: '/order/get-for-feedback',
  UPDATE_ORDER_FEEDBACK: '/order/update-feedback',
  COMPLETE_ORDER_CAMPAIGN: '/order/complete-campaign',
  MASTERPASS_GET_TOKEN: '/order/masterpass-get-token',
  MASTERPASS_COMPLETE_PAYMENT: '/callback/masterpass-order',
  CAMPAIGN: '/product/campaign',
  PRICES: '/product/prices',
  MENU_CATEGORIES: '/product/categories',
  SET_REFERRER_ID: '/order/set-referrer-id',
  ADD_INVITATION_CODE: '/order/add-invitation-code',
  GET_PROMO_CODES: '/order/get-promo-codes',
  GET_REFERRAL_LOGS: '/order/get-referral-logs',
  GET_REFERRAL_PROMO_CODES: '/basket/get-referral-promo-codes',
  UPDATE_PAYMENT_PRESET: '/order/update-payment-preset',
  GET_PROMO_GAME: '/order/get-promo-game',
  PICK_GAME_PROMO_CODE: '/order/pick-game-promo-code',
  CLAIM_BANNER_PROMO: '/order/claim-banner-promo',
  USER_REMOVE_ACCOUNT: '/user/remove',
  GET_FAVORITES: '/user/favorites',
  ADD_FAVORITE: '/user/favorites/add',
  REMOVE_FAVORITE: '/user/favorites/remove',
  GET_ADDRESSES: '/user/addresses',
  CREATE_ADDRESS: '/user/addresses/create',
  UPDATE_ADDRESS: '/user/addresses/update',
  REMOVE_ADDRESS: '/user/addresses/remove',
  PROMOTE_ADDRESS: '/user/addresses/promote',
  BASKET_ADD_PHOTO_PRINT: '/basket/add-photo-print',
  BASKET_UPDATE_PHOTO_PRINT: '/basket/update-photo-print',
  GET_USERS_FOR_LANDING_PAGE: '/user/get-users-for-landing-page',
  GET_LANDING_PAGE: '/product/get-landing-page',
  GET_CHANNEL_LANDING_PAGE: '/product/get-channel-landing-page',
  GET_FAQ_PAGE: '/product/get-faq-page',
  GET_REFERRAL_FAQS: '/product/get-referral-faqs',
  CREATE_LANDING_PAGE_MAIL: '/user/create-landing-page-mail',
  AB_EXPERIMENT_MARK_SEEN: '/user/ab-experiment/mark-seen',
  AB_EXPERIMENTS: '/user/ab-experiments',
};
